import Layout from "../../../components/custom/Layout";

export default function Tickets () {
    return (
        <Layout>
            <h1>test</h1>
        </Layout>
    );
}